<section>
  <div mat-dialog-title>
    <h1 fxFlexAlign="start">Histórico de Pagamentos</h1>
    <div class="box"
         fxLayout="column"
         fxLayoutAlign="start start">
      <span class="box-text">Candidato</span>
      <span>{{data.enrollment.candidatoNome}}</span>
    </div>
  </div>

  <mat-dialog-content fxLayout="row"
                      fxLayoutAlign="start start">
    <app-table-custom class="w-100"
                      [tableData]="table"
                      [data]="contracts">
    </app-table-custom>
  </mat-dialog-content>

  <mat-dialog-actions align="end"
                      fxLayout="row"
                      fxLayoutAlign="space-between center">
    <button color="primary"
            mat-dialog-close
            mat-raised-button>
      <mat-icon>close</mat-icon>
      <span>FECHAR</span>
    </button>
  </mat-dialog-actions>
</section>
